import { render, staticRenderFns } from "./UploadArquivosAr.vue?vue&type=template&id=4a11d4f4&scoped=true&lang=pug"
import script from "./UploadArquivosAr.vue?vue&type=script&lang=js"
export * from "./UploadArquivosAr.vue?vue&type=script&lang=js"
import style0 from "./UploadArquivosAr.vue?vue&type=style&index=0&id=4a11d4f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a11d4f4",
  null
  
)

export default component.exports